export enum ReviewPlatform {
  GOOGLE = "google",
  YELP = "yelp",
  SPOT = "spot",
  SWIVL = "swivl"
}
export enum ReviewReplyPlatform {
  GOOGLE = "google",
  YELP = "yelp",
  SWIVL = "swivl"
}
export enum ReviewHistoryEventType {
  CREATED = "created",
  TEXT_UPDATED = "text_updated",
  OTHER = "other",
  REPLY_CREATED_OUTSIDE_SWIVL = "reply created outside swivl",
  REPLY_UPDATED_OUTSIDE_SWIVL = "reply updated outside swivl",
  REPLY_REMOVED_OUTSIDE_SWIVL = "reply removed outside swivl",
  REPLY_CREATED = "reply created",
  REPLY_UPDATED = "reply updated",
  REPLY_REMOVED = "reply removed",
  REVIEW_UPDATED = "review updated"
}
export enum ReviewGetType {
  ARCHIVED = "archived",
  UNARCHIVED = "unarchived",
  ALL = "all"
}
export enum ReviewAutoReplyStatus {
  PENDING = "pending", // New review, 4-5 stars, auto-reply enabled
  REPLIED = "replied", // Auto-reply generated by AI
  // MANUALLY_GENERATED = "manually_generated", // Manual reply by user
  // EXTERNALLY_ANSWERED = "externally_answered", // Reply added outside the system
  NOT_REQUIRED = "not_required", // Rating < 4 stars or auto-reply disabled
  ERROR = "error", // Error during auto-reply generation
  MANUALLY_REPLIED = "manually_replied" // Manually replied by user
}

export interface ReviewHistoryEvent {
  type: ReviewHistoryEventType;
  date: Date;
  by?: { id: string; name: string };
  data?: { old?: string; new?: string };
}
export interface ReviewInterface {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  isArchived: boolean;
  deletedDate?: Date;

  syncDate: Date;
  orgId: number;
  locationId: number;
  locationLookupId: string; // This corrisponds to either the google account name + location name  or whatever yelp uses.

  platform: ReviewPlatform;

  reviewerUserId?: string; // The swivl user id, if one exists. This is not the same as the google or yelp user id.

  reviewerName: string;
  reviewerAvatarURL: string;
  reviewerIsAnonymous: boolean;

  reviewId: string;
  reviewDate: Date;
  rating: 0 | 1 | 2 | 3 | 4 | 5;
  text: string;

  hasReply: boolean;
  replyText?: string;
  replyDate?: Date;
  repliedByName?: string;
  repliedById?: string;
  replyPlatfrom?: ReviewReplyPlatform;
  autoReplyStatus?: ReviewAutoReplyStatus;

  /** Auto-reply retry state (ENG-3029); see ReviewEntity for the field semantics. */
  replyAttempts?: number;
  nextReplyAttemptAt?: Date | null;
  lastReplyHttpStatus?: number | null;
  lastReplyError?: string | null;

  rawReview?: GoogleLocationReview | YelpLocationReview;
  history: ReviewHistoryEvent[];
}

export interface GoogleLocationReview {
  name: string;
  review: {
    name: string;
    reviewId: string;
    reviewer: {
      profilePhotoUrl: string;
      displayName: string;
      isAnonymous: boolean;
    };

    starRating: any;
    comment: string;
    createTime: string;
    updateTime: string;
    reviewReply: {
      comment: string;
      updateTime: string;
    };
  };
}
export interface ReviewSyncResult {
  error?: string;
  numberOfNewReviews?: number;
  numberOfUpdatedReviews?: number;
}
export interface YelpLocationReview {
  // {
  //     "reviews": {
  //       "review": [
  //         {
  //           "time_created": "2020-06-08 20:00:23",
  //           "rating": 1,
  //           "text": "The moment you walk inside the store you can tell about the \"dollar store\" quality of every single item.  The designs are so depressing and tasteless.",
  //           "url": "https://www.yelp.com/biz/the-brick-vancouver-2?adjust_creative=Ey_LbvkpsGAECYM_cP_3Jw&hrid=QaXIVEd8brM89ctSg4inEw&utm_campaign=yelp_api_v3&utm_medium=api_v3_graphql&utm_source=Ey_LbvkpsGAECYM_cP_3Jw",
  //           "user": {
  //             "name": "Shannon W.",
  //             "image_url": "https://s3-media1.fl.yelpcdn.com/photo/Y8eHsgY2emwWmUOk9TWnZg/o.jpg"
  //           },
  //           "public_response": {
  //             "text": "Hello Shannon W.. From British Columbia, to the Northwest Territories and to Nova Scotia, there is a Brick team focused on saving you more. If you did not find the product that suits your needs in store, don't forget we have a wide variety of options to browse online. Thank you for taking the time to submit a review!",
  //             "time_created": "2020-06-10T21:16:43+00:00",
  //             "business_user": {
  //               "name": "The Brick",
  //               "role": "CUSTOMER_SERVICE",
  //               "photo_url": "https://s3-media1.fl.yelpcdn.com/buphoto/GKx20wV9-mEucKDhsNXw4Q/o.jpg"
  //             }
  //           }
  //         },
  //         {
  //           "time_created": "2009-10-11 10:43:28",
  //           "rating": 2,
  //           "text": "I wonder if someone in their marketing department told the Brick that by putting the word \"Urban\" in front of the store name, that it will make the furniture more appealing?\n\nHmmm, I think not!\n\nInstead of regular poor quality and unstylish furniture, this urban location now stocks poor quality and unstylish furniture that attempts to be more contemporary by having cleaner lines.  It doesn't work and it's still a terrible place to buy furniture.\n\nEverything here is mass produced and materials are terrible in quality - their leather is so cheap that it might as well be PVC.  I don't know if you can get quality below bonded leather, but this would be it.  Lamps are already wobbly in the store.  Sofas are stiff and have all the poor finishing features.\n\nThe Urban Brick is not any better than a regular Brick... you're honestly better off saving your pennies for a sale at a better quality store since I can't imagine having this style in any respectable urban Vancouver home.",
  //           "url": "https://www.yelp.com/biz/the-brick-vancouver-2?adjust_creative=Ey_LbvkpsGAECYM_cP_3Jw&hrid=l7-yn4JLx7jSY8y8cmxgNg&utm_campaign=yelp_api_v3&utm_medium=api_v3_graphql&utm_source=Ey_LbvkpsGAECYM_cP_3Jw",
  //           "user": {
  //             "name": "Chris F.",
  //             "image_url": "https://s3-media3.fl.yelpcdn.com/photo/nslinOHxl7qU3tLUZhLTsQ/o.jpg"
  //           },
  //           "public_response": null
  //         }]}}
}

export interface ReviewSyncJobData {
  locationId: number;
  locationName: string;
  accountAndLocationName: string;
  orgId: number;
  appId: number;
  syncExitingData?: boolean;
}

export interface ReviewData {
  byDateTime: {
    [key: string]: {
      total: number;
      positiveReviews: number;
      negativeReviews: number;
      dayOfWeek: string;
      byTimeOfDay: string;
      locationId: number;
      locationName: string;
      reviews: ReviewInterface[];
    };
  };
  updatedByDateTime: {
    [key: string]: {
      total: number;
      positiveReviews: number;
      negativeReviews: number;
      dayOfWeek: string;
      byTimeOfDay: string;
      locationId: number;
      locationName: string;
      reviews: ReviewInterface[];
    };
  };
}

export interface ReviewAggregatedFilterData {
  status: {
    responded: number;
    notResponded: number;
    deletedOnGoogle: number;
  };
  starRating: {
    [key: string]: number;
  };
  provider: {
    [key: string]: number;
  };
  locations: Array<{
    id: number;
    name: string;
    count: number;
  }>;
}
